module.exports = __webpack_public_path__ + "img/logo.7bca32e9.svg";